'use client';

import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import Hiking from '@alltrails/denali/icons/Hiking';
import styles from './styles.module.scss';

const PrimaryTrailLink = ({ trail }: { trail: { name: string; slug: string } }) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <a className={styles.primaryTrailLink} href={wrapUrlSafe(`/trail/${trail.slug}`, languageRegionCode)}>
      <div className={styles.thumbnail}>
        <Hiking color="--color-text-secondary" size="md" />
      </div>
      <div className={styles.text}>
        <Typography component="div" variant="text200">
          {intl.formatMessage({ defaultMessage: 'This trail relates to' })}
        </Typography>
        <Typography color="secondary" component="div" variant="text100">
          {trail.name}
        </Typography>
      </div>
    </a>
  );
};

export default PrimaryTrailLink;
